import {token,environment} from "../environments/environment";
// @ts-ignore
export let ConfigApp = window.getAppConfig();

export let Services = {
  generateToken: {
    noProxy:true,
    url: environment.portalUrl + "sharing/rest/" + "generateToken",
    method: "POST",
    params: {
      username: null,
      password: null,
      expiration: 60 * 24, //1 giorno
      f: "json",
      client: "referer",
      referer: location.protocol + "//" + location.host,
    },
  },
  self: {
    noProxy:true,
    url:  environment.portalUrl + "sharing/rest/" + "community/self",
    method: "GET",
    params: {
      token: token,
      f: "json",
    },
  }
};

export let microServices = {
  filesList: {
    url: environment.microServices.host,
    method: "POST",
    params: {
      user: environment.microServices.user,
      password: environment.microServices.password,
      codiceCliente: environment.microServices.codiceCliente,
      service: "filesList",
      parameters: {}
    }
  },
  uploadFile: {
    url: environment.microServices.host,
    method: "POST",
    params: {

    }
  },
  createFile: {
    url: environment.microServices.host,
    method: "POST",
    params: {
      user: environment.microServices.user,
      password: environment.microServices.password,
      codiceCliente: environment.microServices.codiceCliente,
      service: "createFile",
      parameters: {
        file_name:"",
        temp_file_name:"",
        group_name:null
      }
    },
  },
  changeStatus: {
    url: environment.microServices.host,
    method: "POST",
    params: {
      user: environment.microServices.user,
      password: environment.microServices.password,
      codiceCliente: environment.microServices.codiceCliente,
      service: "changeStatus",
      parameters: {
        file_id:null,
        status:null
      }
    },
  },
  verifyFile: {
    url: environment.microServices.host,
    method: "POST",
    params: {
      user: environment.microServices.user,
      password: environment.microServices.password,
      codiceCliente: environment.microServices.codiceCliente,
      service: "verifyFile",
      parameters: {
        file_id:null
      }
    },
  },
  insertFile: {
    url: environment.microServices.host,
    method: "POST",
    params: {
      user: environment.microServices.user,
      password: environment.microServices.password,
      codiceCliente: environment.microServices.codiceCliente,
      service: "insertFile",
      parameters: {
        file_id:null
      }
    }
  },
  fileStatus: {
    url: environment.microServices.host,
    method: "POST",
    params: {
      user: environment.microServices.user,
      password: environment.microServices.password,
      codiceCliente: environment.microServices.codiceCliente,
      service: "fileStatus",
      parameters: {
        file_id:null
      }
    }
  }
};



